import React from "react";
import { useNoPptPreviewContext } from "./NoPptPreviewContext";
import { withTooltip } from "@/common/lib";
import "./NoPptPreview.scss";

export interface NoPptPreviewProps {
  section: string
  fieldName?: string
  message?: string
}

export const NoPptPreview: React.FC<NoPptPreviewProps> = ({
  section,
  fieldName,
  message
}) => {
  const { checkSectionAndField } = useNoPptPreviewContext();

  const defaultMessage = fieldName
    ? "This content is not included in the PowerPoint report output."
    : "This section is not included in the PowerPoint report output.";

  const finalMessage = message || defaultMessage;
  const shouldShow = checkSectionAndField(section, fieldName);

  if (!shouldShow) return null;

  return (
    <>
      {withTooltip(
        finalMessage,
        <span
          data-noppt-preview="true"
        />,
        { className: "tooltip-host" }
      )}
    </>
  );
};
